import React from 'react';
import { Link } from 'react-router-dom';
import { Play, ArrowRight, Calendar } from 'lucide-react';
import { contactInfo } from '../mock';

const thumbOf = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

const PreviewCard = ({ v, onPlay, testid }) => (
  <button
    onClick={() => onPlay(v.youtubeId, v.title)}
    data-testid={testid}
    className="group relative rounded-2xl overflow-hidden text-left border border-white/10 hover:border-[#c9a85f]/60 transition-all aspect-video"
  >
    <img src={thumbOf(v.youtubeId)} alt={v.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
    <div className="absolute inset-0 flex items-center justify-center">
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#c9a85f]/90 text-black group-hover:scale-110 transition-transform shadow-xl">
        <Play size={22} className="fill-black ml-1" />
      </span>
    </div>
    <div className="absolute bottom-0 left-0 right-0 p-5">
      <h3 className="font-display font-semibold text-white text-base md:text-lg leading-tight uppercase group-hover:text-[#c9a85f] transition-colors">{v.title}</h3>
    </div>
  </button>
);

// Condensed homepage preview of a full portfolio page (Documentaries / Trades).
const VideoPreviewSection = ({ id, eyebrow, heading, blurb, videos, viewAllTo, viewAllLabel, onPlay }) => (
  <section id={id} className="max-w-7xl mx-auto px-6 py-20 md:py-28" data-testid={`section-${id}`}>
    <div className="text-center mb-14">
      <p className="font-display tracking-[0.4em] text-[#c9a85f] text-sm uppercase mb-4">{eyebrow}</p>
      <h2 className="font-display font-bold text-white text-4xl md:text-5xl uppercase leading-[1.05]">{heading}</h2>
      {blurb && <p className="mt-5 text-white/75 text-base md:text-lg max-w-2xl mx-auto font-normal">{blurb}</p>}
    </div>

    <div className="grid md:grid-cols-3 gap-6">
      {videos.map((v) => (
        <PreviewCard key={v.id} v={v} onPlay={onPlay} testid={`${id}-preview-${v.id}`} />
      ))}
    </div>

    <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
      <a
        href={contactInfo.calendly}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${id}-book-call`}
        className="inline-flex items-center gap-2 bg-[#c9a85f] hover:bg-[#d8b970] text-black font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide"
      >
        <Calendar size={18} /> Book A Call
      </a>
      <Link
        to={viewAllTo}
        onClick={() => window.scrollTo(0, 0)}
        data-testid={`${id}-view-all`}
        className="group inline-flex items-center gap-3 border border-[#c9a85f]/50 hover:bg-[#c9a85f] hover:text-black text-white font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide"
      >
        {viewAllLabel}
        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
      </Link>
    </div>
  </section>
);

export default VideoPreviewSection;
